import { ReferentialKey } from 'api/referential';
import { BaseSection, InputContainer } from 'components/layout/Section/BaseSection';
import { FormikGoogleLocation } from 'components/forms/formik/FormikGoogleLocation';
import { FormikInputText } from 'components/forms/formik/FormikInputText';
import { ReferentialDropdown } from 'features/referentials/components/ReferentialDropdown';
import { NsKey } from 'enums/NsKey';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { FC } from 'react';
import { BorrowerRealEstateFormFieldNames } from './borrowerRealEstateForm';

export const BorrowerRealEstateFormLayout: FC = () => {
  const { t } = useDynamicTranslation([NsKey.Contractualization, NsKey.RealEstate, NsKey.ActorForm, NsKey.Common]);

  return (
    <BaseSection title={t('COMMON.LABELS.COORDINATE')}>
      <InputContainer>
        <div className="col-span-6">
          <FormikGoogleLocation
            name={BorrowerRealEstateFormFieldNames.AddressSearch}
            fieldPrefix={BorrowerRealEstateFormFieldNames.Address}
            required
            label={t('ACTOR_FORM.ADDRESS.LABELS.ADDRESS')}
            placeholder={t('ACTOR_FORM.ADDRESS.PLACEHOLDERS.ADDRESS')}
            countryRestriction="fr"
          />
        </div>
        <div className="col-span-6">
          <FormikInputText
            name={BorrowerRealEstateFormFieldNames.AddressLine2}
            label={t('ACTOR_FORM.ADDRESS.LABELS.ADDITIONAL_ADDRESS')}
            placeholder={t('ACTOR_FORM.ADDRESS.PLACEHOLDERS.ADDITIONAL_ADDRESS')}
          />
        </div>
        <div className="col-span-3">
          <FormikInputText
            name={BorrowerRealEstateFormFieldNames.AddressPostalCode}
            disabled
            label={t('ACTOR_FORM.ADDRESS.LABELS.POSTAL_CODE')}
            placeholder={t('ACTOR_FORM.ADDRESS.PLACEHOLDERS.POSTAL_CODE')}
          />
        </div>
        <div className="col-span-3">
          <FormikInputText
            name={BorrowerRealEstateFormFieldNames.AddressCity}
            disabled
            label={t('ACTOR_FORM.ADDRESS.LABELS.CITY')}
            placeholder={t('ACTOR_FORM.ADDRESS.PLACEHOLDERS.CITY')}
          />
        </div>
        <div className="col-span-6">
          <ReferentialDropdown
            name={BorrowerRealEstateFormFieldNames.AddressCountry}
            referentialKey={ReferentialKey.Country}
            disabled
            label={t('ACTOR_FORM.ADDRESS.LABELS.COUNTRY')}
            placeholder={t('ACTOR_FORM.ADDRESS.PLACEHOLDERS.COUNTRY')}
          />
        </div>
      </InputContainer>
    </BaseSection>
  );
};
